import getAPIPath from '../modules/api-location';

window.userProfilePublicService = function(data, successFn, errorFn) {
  $.ajax({
    url: `${getAPIPath}commandapi/user/profile/public`,
    type: `PUT`,
    data,
    success: successFn,
    error: errorFn,
    async: true,
    dataType: `json`,
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.userProfileThemeService = function(data, successFn, errorFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/user/profile/theme`,
    type: `POST`,
    data,
    success: successFn,
    error: errorFn,
    async: true,
    dataType: `json`,
    cache: false,
    processData: false,
    contentType: false,
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/userprofile.service.js